import { render } from "./EventLogDetailVx.vue?vue&type=template&id=1dcbd354"
import script from "./EventLogDetailVx.vue?vue&type=script&lang=js"
export * from "./EventLogDetailVx.vue?vue&type=script&lang=js"

import "./EventLogDetailVx.vue?vue&type=style&index=0&id=1dcbd354&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__